import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState, AppNotifications, UploadedImageModel } from "../../../../../models";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./CountryForm.type";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { NotificationActions } from "../../../../../store/actions";
import CountryFormPresenter from "./CountryForm.presenter";
import { loadCallback, ImageUtil } from "../../../../../utils";
import { NetWorkService } from "../../../../../services";
class CountryFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      countryPictures: []
    };
  }

  onUploadCountryIcon = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    NetWorkService.uploadImageCountry(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            countryPictures: [
              { id: uuidv4(), src: ImageUtil.buildCountryImgSrc(res.data.data)!, alt: data.alt || "" },
            ],
          });
        }
        else if (res.status === 413) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: `${res.data.message}. The image size should be smaller than 2MB` });
        }
        else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
      });
  };

  onRemoveCountryIcon = (fileId: string) => {
    const icon = this.state.countryPictures.filter((p) => p.id !== fileId);
    this.setState({
      countryPictures: icon,
    });
  };

  onSubmit = (val: any) => {
    const countryIcon = this.state.countryPictures[0];

    let data = {
      name: val.name, 
      image: ImageUtil.convertImgServerSrc(countryIcon.src, "country"),
    };
    this.onCreateCountry(data);
  };

  onCreateCountry = (data) => {
    NetWorkService.createCountry(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create country success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Create country failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Create country failed",
        });
      });
  };

  render() {
    return (
      <>
        <CountryFormPresenter
          {...this.props}
          {...this.state}
          onUploadCountryIcon={this.onUploadCountryIcon}
          onRemoveCountryIcon={this.onRemoveCountryIcon}
          onSubmit={this.onSubmit}
        />
      </>
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(CountryFormContainer)
);
